import { Component, OnInit, signal, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { PaymentType } from '../../../../../shared/enums/payment-type';
import { RequestBuilderService } from '../../../../../shared/services/request-builder.service';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-waiting-time-dialog',
  standalone: true,
  imports: [FormsModule, ButtonComponent, AutoCompleteModule, SelectModule, InputNumberModule, CheckboxModule],
  templateUrl: './waiting-time-dialog.component.html',
  styleUrl: './waiting-time-dialog.component.scss',
})
export class WaitingTimeDialogComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly requestBuilder = inject(RequestBuilderService);

  loading = false;
  reason: string = '';
  suggestions: string[] = [];
  waitingTimeDetails: any;
  isApproved = false;
  filteredSuggestions: string[] = [];
  paymentTypeOptions = signal<{ name: string; id: number }[]>([
    { name: 'Payable Only', id: PaymentType.PayableOnly },
    { name: 'Receivable Only', id: PaymentType.ReceivableOnly },
    { name: 'Both', id: PaymentType.Both },
  ]);
  waitingTimePayout = 0;
  waitingTimeInMinutes = 0;
  selectedPaymentType: number | null = null;

  ngOnInit() {
    this.getWaitingTimeDetails();
    this.filteredSuggestions = [...this.suggestions];
  }

  filterSuggestions(event: any, autoComplete: AutoComplete) {
    if (this.reason) {
      this.filteredSuggestions = this.suggestions.filter(suggestion => suggestion.toLowerCase().includes(this.reason.toLowerCase()));
    } else {
      this.filteredSuggestions = [...this.suggestions];
      if (this.filteredSuggestions.length > 0) {
        autoComplete.show();
      }
    }
  }

  updatePayout() {
    const waitingTimeIncrements = this.waitingTimeDetails?.WaitingTimeMinuteIncrements ?? 0;
    const waitingTimeHourlyFee = this.waitingTimeDetails?.WaitingTimeHourlyFee ?? 0;

    let waitingTimePayout = this.waitingTimeInMinutes > 0 && waitingTimeIncrements > 0 ? (Math.ceil(this.waitingTimeInMinutes / waitingTimeIncrements) * waitingTimeIncrements * waitingTimeHourlyFee) / 60 : 0;

    this.waitingTimePayout = waitingTimePayout;
  }

  getWaitingTimeDetails() {
    this.requestBuilder.get(`rides/${this.config.data.uuid}/waiting-time`).subscribe({
      next: res => {
        this.waitingTimeDetails = res.data;

        this.setInitialData();

        this.selectedPaymentType = res.data.PayingType > 0 ? res.data.PayingType : null;
      },
      error: error => {},
    });
  }

  private setInitialData() {
    this.waitingTimeInMinutes = this.waitingTimeDetails.TotalBillableWaitingTimeInMinutes;
    this.reason = this.waitingTimeDetails.InternalNote;
    this.isApproved = this.waitingTimeDetails.ApprovedStatusId == 10;
    this.waitingTimePayout = this.waitingTimeDetails.PayoutWaitingTimeFee ?? 0;
  }

  confirmAction(form: NgForm) {
    if (form?.invalid) return;

    this.loading = true;

    const body = {
      waitingTimeInMinutes: this.waitingTimeInMinutes,
      isConfirmed: form.form.value.isConfirmed ?? false,
      payingType: this.selectedPaymentType,
      internalNote: form.form.value.reason,
    };

    this.requestBuilder.patch(`rides/${this.config.data.uuid}/waiting-time`, body).subscribe({
      next: () => {
        this.loading = false;
        this.ref.close({ confirmed: true });
      },
      error: error => {
        this.loading = false;
      },
    });
  }
}
